import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import productCenter from '@/components/productCenter/productCenter';
import productDetail from '@/components/productDetail/productDetail';
import walkintoXinhaitong from '@/components/walkintoXinhaitong/walkintoXinhaitong';
import history from '@/components/walkintoXinhaitong/history';
import intellectualPropertyandPatent from '@/components/walkintoXinhaitong/intellectualPropertyandPatent';
import totalQualityManagement from '@/components/walkintoXinhaitong/totalQualityManagement';
import saleServe from '@/components/saleServe/saleServe';
import contactUs from '@/components/contactUs/contactUs';





Vue.use(Router)

export default new Router({
  routes: [{
    path: '/',
    name: 'index',
    component: index
  }, {
    path: '/productCenter',
    component: productCenter
  }, {
    path: '/productDetail',
    component: productDetail
  }, {
    path: '/walkintoXinhaitong',
    component: walkintoXinhaitong
  }, {
    path: '/history',
    component: history
  }, {
    path: '/intellectualPropertyandPatent',
    component: intellectualPropertyandPatent
  }, {
    path: '/totalQualityManagement',
    component: totalQualityManagement
  }, {
    path: '/saleServe',
    component: saleServe
  }, {
    path: '/contactUs',
    component: contactUs
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js